import { render } from "./ReferenceCard.vue?vue&type=template&id=7f9b487e&scoped=true"
import script from "./ReferenceCard.vue?vue&type=script&lang=js"
export * from "./ReferenceCard.vue?vue&type=script&lang=js"

import "./ReferenceCard.vue?vue&type=style&index=0&id=7f9b487e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9b487e"]])

export default __exports__